export const customerReviews = [
    {

        reviewId: 1,
        customerName: "Kevin",
        customerTitle: "",
        customerLocation: "Missouri, USA",
        customerReview: "I was looking for the record my parents first danced to at their high school dance as a gift for their 50th anniversary. I called Rare Finds and I had the record in my hands a week later for a reasonable price.",
        dateCreated: "December 1, 2023"

    },
    {

        reviewId: 2,
        customerName: "DJ MadMan",
        customerTitle: "",
        customerLocation: "Belize",
        customerReview: "Anytime I’m in Amsterdam, spending several hours at Rare Finds is a must as a music fan, producer and DJ.",
        dateCreated: "June 20, 2023"

    },
    {

        reviewId: 3,
        customerName: "DubbKings",
        customerTitle: "P",
        customerLocation: "U.K.",
        customerReview: "Spent time in the Netherlands looking for obscure jazz records for our next album, Jim provided us with GEMS that took our album to another level.",
        dateCreated: "January 11, 2024"

    },

    {

        reviewId: 4,
        customerName: "Volume Magazine",
        customerTitle: "",
        customerLocation: "Australia",
        customerReview: "If you're a vinyl collector, music enthusiasts or someone that misses walking around a record shop, you need to make a trip to Rare Finds.",
        dateCreated: "March 3, 2024"

    },

    {

        reviewId: 5,
        customerName: "Tony - TouchPod Productions",
        customerTitle: "",
        customerLocation: "New York, NY",
        customerReview: "Anytime we book a commercial shoot, if it requires music, we call Jim for recommendations and he never lets us down.",
        dateCreated: "June 20, 2024"

    },
    {

        reviewId: 6,
        customerName: "Tech, Primetime Productions",
        customerTitle: "",
        customerLocation: "Johannesburg",
        customerReview: "My favorite record store in the world.",
        dateCreated: "July 14, 2024"

    },


]